/**
 * @file     byline.ts
 * @purpose  Byline helpers for the article header. updated_at moves on every
 *           save, including the publish itself, so "Updated" only shows when
 *           the edit landed on a later calendar day than the publication.
 */

const dayOf = (iso: string): string => iso.slice(0, 10);

export function isVisiblyUpdated(publishedAt: string, updatedAt?: string | null): boolean {
  if (!updatedAt) return false;
  return dayOf(updatedAt) > dayOf(publishedAt);
}

/** Splits "By {{name}}" into the text before and after the name slot. */
export function splitNameTemplate(template: string): [string, string] {
  const [before = '', after = ''] = template.split('{{name}}');
  return [before, after];
}
